var RequestType;
(function (RequestType) {
    RequestType[RequestType["GET"] = 0] = "GET";
    RequestType[RequestType["POST"] = 1] = "POST";
    RequestType[RequestType["PUT"] = 2] = "PUT";
    RequestType[RequestType["DELETE"] = 3] = "DELETE";
    RequestType[RequestType["PATCH"] = 4] = "PATCH";
})(RequestType || (RequestType = {}));
var RequestStatusType;
(function (RequestStatusType) {
    RequestStatusType[RequestStatusType["SUCCESS"] = 0] = "SUCCESS";
    RequestStatusType[RequestStatusType["ERROR"] = 1] = "ERROR";
    RequestStatusType[RequestStatusType["IDLE"] = 2] = "IDLE";
    RequestStatusType[RequestStatusType["IN_PROGRESS"] = 3] = "IN_PROGRESS";
    RequestStatusType[RequestStatusType["CANCELLED"] = 4] = "CANCELLED";
})(RequestStatusType || (RequestStatusType = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(e) {
        var _this = _super.call(this) /* istanbul ignore next */ || this;
        _this.status = 0;
        _this.subcode = "";
        _this.message = "";
        _this.details = "";
        _this.data = {};
        /**
         * Used to print the error
         *
         * @returns {string} stringified error
         */
        _this.toString = function () {
            return "[" + _this.subcode + "] " + _this.details + " " + _this.message;
        };
        if (typeof e === "string")
            _this.subcode = e;
        else {
            var status_1 = e.status, message = e.message, subcode = e.subcode, details = e.details, data = __rest(e, ["status", "message", "subcode", "details"]);
            _this.status = status_1;
            _this.message = message;
            _this.subcode = subcode;
            _this.details = details;
            _this.data = data;
        }
        return _this;
    }
    return ApiError;
}(Error));

/**
 * Dictonnary of response transformers that takes the response
 * of the request and returns the data transformed
 */
var ResponseParsers = {
    "application/json": function (xhr) { return JSON.parse(xhr); },
    "application/text": function (xhr) { return xhr.toString(); }
};
var BodyTypes = {
    "json": "application/json"
};
var RequestTypeToString = function (t) {
    switch (t) {
        case RequestType.GET:
            return "GET";
        case RequestType.DELETE:
            return "DELETE";
        case RequestType.POST:
            return "POST";
        case RequestType.PUT:
            return "PUT";
        case RequestType.PATCH:
            return "PATCH";
    }
};
/**
 * Request class.
 * Used to make XMLHttpRequest
 * We used XMLHttpRequest instead of fetch for now because fetch lack some feature like upload progress.
 */
var Request = /** @class */ (function () {
    /**
     *
     * @param {RequestType} type Type of request (GET, POST, PUT, DELETE)
     * @param {string} url Complete URL to call
     * @param {IRequestData} data Data that will be sent with POST | PUT | DELETE requests
     * @param {RequestHeadersType} headers Headers to be added to request
     */
    function Request(type, url, data, headers) {
        if (headers === void 0) { headers = {}; }
        this.timeout = 10000;
        this.progress = 0;
        this.total = 0;
        this.loaded = 0;
        this.onProgressCB = null;
        this.type = type;
        this.url = url;
        this.headers = headers;
        this.data = data;
        this.xhr = new XMLHttpRequest();
        this.status = RequestStatusType.IDLE;
        this.bodyContentType = "form-encode";
    }
    /**
     * Used to add headers in request headers
     *
     * @param {string} key Key of header
     * @param {string} value Content of header
     */
    Request.prototype.AddHeader = function (key, value) {
        this.headers[key] = value;
    };
    /**
     * Used to set data that will be sent with PUT/POST/DELETE requests
     *
     * @param {IRequestData} data data to send via PUT/POST/DELETE
     */
    Request.prototype.SetData = function (data) {
        this.data = data;
    };
    /**
     * Set the request response type.
     * Usefull if we need a blob for exemple
     *
     * @param {XMLHttpRequestResponseType} type
     */
    Request.prototype.SetResponseType = function (type) {
        this.responseType = type;
    };
    /**
     * Set Body Content Type
     *
     * @param type "form-encode" or "json"
     */
    Request.prototype.SetBodyType = function (type) {
        this.bodyContentType = type;
    };
    /**
     * Send the request
     * return a promise.
     * If then response code is not between 200 and 300, we throw an ApiError
     *
     * @returns {Promise<any>} resolved when request success, reject if request fail or any other error
     */
    Request.prototype.Send = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.xhr.open(RequestTypeToString(_this.type), _this.url, true);
            _this.xhr.timeout = _this.timeout;
            if (_this.responseType)
                _this.xhr.responseType = _this.responseType;
            Object.keys(_this.headers).map(function (k) { return _this.xhr.setRequestHeader(k, _this.headers[k]); });
            if (_this.bodyContentType !== "form-encode")
                _this.xhr.setRequestHeader("Content-Type", BodyTypes[_this.bodyContentType] || undefined);
            _this.xhr.onprogress = function (event) {
                _this.total = event.total;
                _this.loaded = event.loaded;
                _this.progress = (event.loaded * 100) / event.total;
                if (_this.onProgressCB)
                    _this.onProgressCB(_this);
            };
            _this.xhr.onloadstart = function () {
                _this.status = RequestStatusType.IN_PROGRESS;
            };
            _this.xhr.onloadend = function () {
                var handler = _this.responseType !== "blob" ? ResponseParsers[_this.xhr.getResponseHeader("content-type")] : null;
                var result = handler ? handler(_this.xhr.response) : _this.xhr.response;
                if (_this.xhr.status) {
                    if (_this.xhr.status >= 200 && _this.xhr.status < 300) {
                        _this.status = RequestStatusType.SUCCESS;
                        resolve(result);
                    }
                    else {
                        _this.status = RequestStatusType.ERROR;
                        reject(new ApiError(result));
                    }
                }
            };
            _this.xhr.onerror = function () {
                _this.status = RequestStatusType.ERROR;
                reject(new ApiError("NetworkFailed"));
            };
            _this.xhr.onabort = function () {
                _this.status = RequestStatusType.CANCELLED;
                reject(new ApiError("RequestCancelled"));
            };
            _this.xhr.ontimeout = function () {
                _this.status = RequestStatusType.ERROR;
                reject(new ApiError("RequestTimeout"));
            };
            var fd = undefined;
            if (_this.bodyContentType === "form-encode") {
                if (_this.data) {
                    fd = new FormData();
                    Object.keys(_this.data).map(function (k) {
                        var value = _this.data[k];
                        if (value !== undefined) {
                            if (Array.isArray(value))
                                value.forEach(function (subValue) { return fd.append(k + "[]", subValue); });
                            else
                                fd.append(k, value);
                        }
                    });
                }
            }
            else if (_this.bodyContentType === "json")
                fd = JSON.stringify(_this.data);
            _this.xhr.send(fd);
        });
    };
    /**
     * Used to specify the timeout for this call
     * Must be called before Send()
     *
     * @param {number} timeout Value of timeout in ms
     * @returns {Request} this instance
     */
    Request.prototype.SetTimeout = function (timeout) {
        this.timeout = timeout;
        return this;
    };
    /**
     * Used to specify a callback to be called when
     * the progress of the request updates.
     * Usefull to display a progress bar for exemple
     *
     * @param {RequestCallbackType} callback Callback function to be called when the progress updates
     * @returns {Request} this instance
     */
    Request.prototype.OnProgress = function (callback) {
        this.onProgressCB = callback;
        return this;
    };
    /**
     * Used to cancel the Request
     */
    Request.prototype.Cancel = function () {
        this.xhr.abort();
    };
    return Request;
}());

/**
 * Class to be used to make Api calls
 * It'll use Request to make to calls
 */
var Api = /** @class */ (function () {
    /**
     *
     * @param {string} baseUrl Base part of the url to be called.
     *                         It will be append to the endpoints called
     */
    function Api(baseUrl) {
        this.baseUrl = "";
        this.baseUrl = baseUrl || "";
        this.headers = {};
    }
    /**
     * Used to add headers that will be added to each requests
     *
     * @param {string} key Key of header
     * @param {string} value Content of header
     */
    Api.prototype.AddHeader = function (key, value) {
        this.headers[key] = value;
    };
    /**
     * Used to make the request,
     * Returns the Promise of the Request.
     *
     * @param {RequestType} type Request type (GET, POST, PUT, DELETE)
     * @param {string} endpoint Endpoint of the call. The baseUrl will be append to it.
     * @param {RequestOptions | undefined} options Options of the request.
     * @returns {Promise<any>} the promise returned by Request.Send
     */
    Api.prototype.MakeRequest = function (type, endpoint, data, options) {
        var request = new Request(type, "" + this.baseUrl + endpoint, data, this.headers);
        if (options === null || options === void 0 ? void 0 : options.onProgress)
            request.OnProgress(options.onProgress);
        if (options === null || options === void 0 ? void 0 : options.timeout)
            request.SetTimeout(options.timeout);
        if (options === null || options === void 0 ? void 0 : options.responseType)
            request.SetResponseType(options.responseType);
        if (options === null || options === void 0 ? void 0 : options.bodyType)
            request.SetBodyType(options.bodyType);
        return request.Send();
    };
    /**
     * Used to make Get calls.
     *
     * @param {string} endpoint Endpoint of the call. The baseUrl will be append to it.
     * @param {RequestOptions} options Options of the request.
     * @returns {Promise<any>} The promise returned by MakeRequest which is the request returned by Request.Send
     */
    Api.prototype.Get = function (endpoint, options) {
        return this.MakeRequest(RequestType.GET, endpoint, undefined, options);
    };
    Api.prototype.Put = function (endpoint, data, options) {
        return this.MakeRequest(RequestType.PUT, endpoint, data, options);
    };
    Api.prototype.Patch = function (endpoint, data, options) {
        return this.MakeRequest(RequestType.PATCH, endpoint, data, options);
    };
    Api.prototype.Post = function (endpoint, data, options) {
        return this.MakeRequest(RequestType.POST, endpoint, data, options);
    };
    Api.prototype.Del = function (endpoint, data, options) {
        return this.MakeRequest(RequestType.DELETE, endpoint, data, options);
    };
    return Api;
}());

export { Api, ApiError, Request, RequestStatusType, RequestType };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@TaankYou/api/dist/index.es.js
// module id = ./node_modules/@TaankYou/api/dist/index.es.js
// module chunks = 0